import { render, staticRenderFns } from "./SimpleCollection.vue?vue&type=template&id=6c72f0ef"
import script from "./SimpleCollection.vue?vue&type=script&lang=js"
export * from "./SimpleCollection.vue?vue&type=script&lang=js"
import style0 from "./SimpleCollection.vue?vue&type=style&index=0&id=6c72f0ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports